import type { ReactNode } from "react";

export type TagKind =
  | "default"
  | "running"
  | "planned"
  | "completed"
  | "review"
  | "canceled"
  | "imported"
  | "mobile";

const KINDS: Record<TagKind, string> = {
  running:   "bg-mef-green text-white border-transparent",
  planned:   "bg-white text-mef-green-text border-mef-green",
  completed: "bg-mef-green-tint text-mef-green-text border-mef-green",
  review:    "bg-mef-yellow-tint text-[#B28000] border-mef-yellow",
  canceled:  "bg-mef-red-tint text-mef-red border-mef-red",
  imported:  "bg-white text-black/60 border-mef-gray",
  mobile:    "bg-mef-dark text-white border-transparent",
  default:   "bg-white text-black/80 border-mef-gray",
};

export function Tag({ kind = "default", children }: { kind?: TagKind; children: ReactNode }) {
  return (
    <span
      className={[
        "inline-block px-2 py-0.5 rounded-xs border-[1.2px]",
        "text-[10px] leading-4 font-medium uppercase tracking-[0.04em]",
        KINDS[kind],
      ].join(" ")}
    >
      {children}
    </span>
  );
}
